module.exports = __webpack_public_path__ + "static/img/6.e84e66c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/article/6.jpg
// module id = Etna
// module chunks = 1